"use client";

import React from "react";
export default function Location() {
  return null;
}